import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Subject} from 'rxjs';
import {ImageDialogComponent} from '../image-dialog/image-dialog.component';
import {ApiService} from '../services/api.service';
import {debounceTime} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {AppComponent} from '../app.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-darshan-pass-print',
  templateUrl: './darshan-pass-print.component.html',
  styleUrls: ['./darshan-pass-print.component.scss']
})
export class DarshanPassPrintComponent implements OnInit {

 registraionDetail:any;
 url_data: any;
 reg_id;
  // param_qr_id = '';

  pnr_no = '' ;
  public from_date = moment(new Date()).format('YYYY-MM-DD');
  public onChangeSearch = new Subject<string>();
  public errorMsg = '';
  public successMsg = '';
  public loading = false;

  constructor(
    private appComponent: AppComponent,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
  ) { 
    this.pnr_no  = this.route.snapshot.params.id;
  }

  ngOnInit() {
    this.onChangeSearch
      .pipe(debounceTime(1500))
      .subscribe(() => {
        if(this.pnr_no){
          // if (this.registraionNo && this.registraionNo.length > 8 && this.registraionNo.substring(0, 18) == 'Registration ID : ') {
          //   this.registraionNo = this.registraionNo.substring(18);
          // }
          this.getVisitorDetail();
        }
      });

      if(this.route.snapshot.params.id){
        this.getVisitorDetail();
      }
  }


  viewImage(imageUrl){
    const modalRef = this.modalService.open(ImageDialogComponent,
      {
        centered: false, size: 'md', windowClass: 'my-class', scrollable: false,
        backdrop: 'static', keyboard: false,
      });
    const imageDialogComponent: ImageDialogComponent = modalRef.componentInstance;
    imageDialogComponent.imageUrl = `${imageUrl}`;
  }

  loadData() {
    if(!this.pnr_no) {
      this.appComponent.showMessageAlert('Please enter PNR No.', 'error');
      return;
    }
    this.getVisitorDetail();
  }

  getVisitorDetail() {
    this.appComponent.showLoader();
    this.errorMsg = '';
    const from_date = moment(this.from_date).format('YYYY-MM-DD');
    this.apiService.getDataFromServer(`/search_visitor_by_pnr?pnr_no=${this.pnr_no}&date_of_visit=${from_date}`).subscribe(
      (res: any) => {
        this.registraionDetail = res && res.data;
        this.reg_id = this.registraionDetail.id;
        this.errorMsg = '';
        this.appComponent.hideLoader();
        this.loading = false;
      },
      err => {
        this.errorMsg = err.error.error[0].message;
        this.registraionDetail = null;
        this.appComponent.hideLoader();
        this.appComponent.showMessageAlert(err.error.error[0].message, 'error');
        this.loading = false;
      }
    );
  }


  saveData() {
      this.appComponent.showLoader();
      this.apiService.getDataFromServer(`/generate_entry_pass/${this.reg_id}`).subscribe(
        (res: any) => {
          this.url_data = res && res.data;
          console.log(this.url_data);
          
          if(this.url_data && this.url_data.length > 0) {
            const pdfUrl = this.url_data[0];
            this.printPDF(pdfUrl);
            this.appComponent.showMessageAlert('Entry pass generated successfully', 'success');
          }
          this.appComponent.hideLoader();
        },
        err => {
          this.errorMsg = err.error.error[0].message;
          this.appComponent.hideLoader();
          this.appComponent.showMessageAlert(err.error.error[0].message, 'error');
          this.loading = false;
        }
      );
  }

  printPDF(pdfUrl: string) {
    const printWindow = window.open(pdfUrl, '_blank');
    if(printWindow) {
      printWindow.addEventListener('load', () => {
        setTimeout(() => {
          printWindow.print();
        }, 250);
      });
    }
  }

  public changeSearchValue(): void {
    this.successMsg = '';
    this.loading = true;
    this.registraionDetail = null;
    this.errorMsg = '';
    this.onChangeSearch.next();
  }

}
